<template>
    <v-layout row wrap align-center>
        <v-flex xs4 class="pr-2" v-if="label">
            <span class="caption grey--text">{{label}}</span>
        </v-flex>
        <v-flex xs4 class="pr-2">
            <v-select
                :items="presetItems"
                :label="'Timeline'|translate"
                v-model="selectedPreset"
                @change="onPresetChange"
                hide-details
                dense
            ></v-select>
        </v-flex>
        <v-flex xs4 v-if="selectedPreset === 'custom'">
            <date-range-selector v-model="customRange" @input="onCustomRangeChange"></date-range-selector>
        </v-flex>
    </v-layout>
</template>

<script>
import moment from 'moment/moment';
import DateRangeSelector from './DateRangeSelector';

export default {
    name: 'TimelineParameterSelector',
    components: { DateRangeSelector },
    props: {
        value: { type: Object, default: null },
        label: { type: String, default: '' },
        defaultPreset: { type: String, default: '30 days' },
    },
    data() {
        return {
            selectedPreset: this.defaultPreset || '30 days',
            customRange: { start: null, end: null },
            presetItems: [
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Last 30 Days') : 'Last 30 Days', value: '30 days' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Current Week') : 'Current Week', value: 'current week' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Current Month') : 'Current Month', value: 'current month' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Current Year') : 'Current Year', value: 'current year' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Last Week') : 'Last Week', value: 'last week' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Last Month') : 'Last Month', value: 'last month' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Last Year') : 'Last Year', value: 'last year' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Yesterday') : 'Yesterday', value: 'yesterday' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Today') : 'Today', value: 'today' },
                { text: this.$options.filters && this.$options.filters.translate ? this.$options.filters.translate('Custom (input from user)') : 'Custom (input from user)', value: 'custom' },
            ],
        };
    },
    mounted() {
        // Emit initial resolved value
        this.emitResolved();
    },
    methods: {
        resolvePreset(preset) {
            let maxDate = this.$store && this.$store.state.pointsListStore && this.$store.state.pointsListStore.pointsList
                ? this.$store.state.pointsListStore.pointsList.data_max_date
                : null;
            let baseDate = maxDate ? moment(maxDate) : moment();
            let startDate = baseDate.clone().subtract(30, 'days');

            if (preset === 'current week') {
                startDate = baseDate.clone().startOf('week');
            } else if (preset === 'current month') {
                startDate = baseDate.clone().startOf('month');
            } else if (preset === 'current year') {
                startDate = baseDate.clone().startOf('year');
            } else if (preset === 'last week') {
                baseDate = baseDate.clone().subtract(1, 'week').endOf('week');
                startDate = baseDate.clone().startOf('week');
            } else if (preset === 'last month') {
                baseDate = baseDate.clone().subtract(1, 'month').endOf('month');
                startDate = baseDate.clone().startOf('month');
            } else if (preset === 'last year') {
                baseDate = baseDate.clone().subtract(1, 'year').endOf('year');
                startDate = baseDate.clone().startOf('year');
            } else if (preset === 'yesterday') {
                baseDate = baseDate.clone().subtract(1, 'day').endOf('day');
                startDate = baseDate.clone().startOf('day');
            } else if (preset === 'today') {
                startDate = baseDate.clone().startOf('day');
            }

            if (preset === 'yesterday' || preset === 'today') {
                return {
                    start: startDate.format('YYYY-MM-DD HH:mm:ss'),
                    end: baseDate.format('YYYY-MM-DD HH:mm:ss'),
                };
            }
            return {
                start: startDate.format('YYYY-MM-DD'),
                end: baseDate.format('YYYY-MM-DD'),
            };
        },
        onPresetChange(val) {
            if (val !== 'custom') {
                this.emitResolved();
            }
        },
        onCustomRangeChange(val) {
            this.$emit('input', val);
        },
        emitResolved() {
            if (this.selectedPreset === 'custom') {
                if (this.customRange && this.customRange.start && this.customRange.end) {
                    this.$emit('input', this.customRange);
                }
            } else {
                this.$emit('input', this.resolvePreset(this.selectedPreset));
            }
        },
    },
};
</script>
